const getRibbon = (data, ribbon) => {
  if (ribbon) {
    const { key, definitions } = ribbon;
    const value = data[key];

    return definitions.find(d => d.value === value);
  }
  return null;
};

export default getRibbon;
